import * as S from "./style"
import { ProfileBadgeProps } from "./types";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import UserProfileMenu from 'components/UserProfileMenu';
import { LANGUAGE_FLAGS } from "common/constant/languages";

const ADMIN_FRONTEND_URL = process.env.REACT_APP_ADMIN_FRONTEND_URL || 'http://localhost:3001';

export default function ProfileBadge(props: ProfileBadgeProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleMenuClose();
    navigate('/profile');
  };

  const handleSettings = () => {
    handleMenuClose();
    navigate('/settings');
  };

  const handleGuidelines = () => {
    handleMenuClose();
    navigate('/guidelines');
  };

  const handleLogout = async () => {
    handleMenuClose();
    await logout();
    navigate('/login');
  };

  const handleAdmin = () => {
    handleMenuClose();
    window.open(ADMIN_FRONTEND_URL, '_blank');
  };

  if (!user) {
    return null;
  }

  const initials = user.full_name
    ? user.full_name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2)
    : user.username.substring(0, 2).toUpperCase();

  return (
    <>
      <S.StyledMenuOpener onClick={handleMenuOpen} hideHoverBg={props.hideText}>
        <S.StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={LANGUAGE_FLAGS[user.language] ?? LANGUAGE_FLAGS["en"]}
        >
          <S.StyledAvatar src={user.avatar_url ?? undefined}>
            {initials}
          </S.StyledAvatar>
        </S.StyledBadge>
        {!props.hideText && <S.ProfileNameContainer>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <S.StyledTypographyName variant="body2">
              {user.full_name || user.username}
            </S.StyledTypographyName>
            {user.role === 'superadmin' && (
              <S.StyledSuperAdminChip label="superadmin" size="small" />
            )}
          </Box>
          <S.StyledTypographyEmail variant="caption" color="text.secondary">
            {user.email}
          </S.StyledTypographyEmail>
        </S.ProfileNameContainer>}
      </S.StyledMenuOpener>
      <UserProfileMenu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        userRole={user.role === 'superadmin' ? 'superuser' : 'demo'}
        onProfile={handleProfile}
        onSettings={handleSettings}
        onGuidelines={handleGuidelines}
        onAdmin={handleAdmin}
        onLogout={handleLogout}
      />
    </>
  );
};